export default __webpack_public_path__ + "static/media/Create-documentation.4be471bb.md";